import { CSSProperties, FC } from 'react';

interface ImageErrorProps {
  src?: string;
  alt?: string;
  style?: CSSProperties;
  onLoad?: () => void;
  className?: string;
}

const ImageError: FC<ImageErrorProps> = (props) => (
  <img
    {...props}
    alt={props.alt || 'image'}
    onError={(e) => {
      e.currentTarget.src = '/images/empty_thumbnail.png';
    }}
  />
);

export { ImageError };
